export const KEP_MAX_DB = 5;
export const KEP_MAX_MERET = 5 * 1024 * 1024;
export const KEP_TIPUSOK = ['image/png', 'image/jpeg', 'image/webp'] as const;

export interface KepFajl { type: string; size: number; name: string }

export interface KepEllenorzes<T extends KepFajl> { elfogadott: T[]; hibak: string[] }

/** A meglévő darabszámhoz képest elfogadható új képek; a visszautasítottakról magyar üzenet. */
export function kepekEllenorzese<T extends KepFajl>(meglevo: number, uj: T[]): KepEllenorzes<T> {
  const elfogadott: T[] = [];
  const hibak: string[] = [];
  for (const f of uj) {
    if (!(KEP_TIPUSOK as readonly string[]).includes(f.type)) hibak.push(`${f.name || 'A kép'}: csak PNG, JPEG vagy WebP kép csatolható.`);
    else if (f.size > KEP_MAX_MERET) hibak.push(`${f.name || 'A kép'}: a kép legfeljebb 5 MB lehet.`);
    else if (f.size <= 0) hibak.push(`${f.name || 'A kép'}: a fájl üres.`);
    else if (meglevo + elfogadott.length >= KEP_MAX_DB) hibak.push(`Legfeljebb ${KEP_MAX_DB} kép csatolható.`);
    else elfogadott.push(f);
  }
  return { elfogadott, hibak: [...new Set(hibak)] };
}
